<template>
  <div>
    <table v-if="categories.length > 0" style="width:500px;">
      <tr>
        <th v-for="key in Object.keys(categories[0])" :key="key">
          {{key}}
        </th>
      </tr>
      <tr v-for="(row, index) in categories" :key="index">
        <td v-for="key in Object.keys(categories[index])" :key="key">
          {{row[key]}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CategoriesCRUD',
  props: ['location'],
  data () { return { 
    categories: [],
    
    }
  },
  created: function(){
    this.loadData();
  },
  methods : {
    loadData: function(){
      this.categories = []
      console.log('Loading Categories')
      this.$axios.get(`/api/${this.location}/categories`).then((r)=>{
        this.categories = r.data;
        console.log('Categories')
        console.log(r.data)
      });
    },
  }, 
}
</script>
